import {
  Button,
  Divider,
  FormControl,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Loader from "../../layout/Loader";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/styles";
import { ApiEndPoints } from "../../apis/ApiEndPoints";
import {  fetchList } from "../../apis/services/CommonApiService";
import ReactToPrint from "react-to-print";
import moment from "moment";
import { connect } from "react-redux";
import { convertToKeyValue, getMinDateForLimited, splitNumber } from "../../utils/helper";
import { DatePicker } from "@mui/x-date-pickers";
import ZOutReportPrint from "../NightReports/ZOutReport/ZOutReportPrint";
import { zOutReportDataSuccess, zOutSearchFiltersSuccess } from "../../Reducer/reportSlice";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const ZOutReport = (props) => {
const {
  reportData: storeReportData,
  searchFilters: storeSearchFilters,
  setReportData,
  searchFilterSuccess,
  embedded = false,
  date,
} = props;

  const [localData, setLocalData] = useState({});
  const reportData = embedded ? localData : storeReportData;
  const searchFilters = embedded
    ? { startDate: date, endDate: date }
    : storeSearchFilters;

  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const setSearchFilters = (props) => {
    searchFilterSuccess(convertToKeyValue(props));
  };

  let componentRef = useRef();
  const getReportData = async () => {
    if (embedded || reportData?.length === 0) {
      setLoading(true);
    }
    const result = await fetchList(
      ApiEndPoints.GET_Z_OUT_REPORT_BY_DATE_RANGE +
        `?start_date=${searchFilters.startDate}&end_date=${searchFilters.endDate}`
    );
    if (result?.status === 200) {
      embedded ? setLocalData(result.data) : setReportData(result.data);
      // setAuditStatus(result?.data?.nightAuditStatus);
      setLoading(false);
    } else {
      setLoading(false);
      embedded ? setLocalData({}) : setReportData({});
    }
  };

  useEffect(() => {
    if (searchFilters?.startDate && searchFilters?.endDate) {
      getReportData();
    }
  }, [embedded, date]);

  const applyAction = () => {
    if (searchFilters?.startDate && searchFilters?.endDate) {
      setLoading(true);
      getReportData();
    }
  };



  return (
    <div className="main-layout-background h-auto">
      {loading && <Loader />}
      {!embedded && (
      <>
      <Grid
        container
        spacing={2}
        style={{ marginBottom: "20px" }}
        alignItems="flex-end"
      >
        <Grid item md={4} xs={12}>
          <FormControl fullWidth>
            <Typography
              id="font-600"
              style={{
                marginBottom: "11px",
                color: "rgb(30, 30, 30)",
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: "500 !important",
              }}
            >
              {t("Start Date")}
            </Typography>
            <DatePicker
              format="MM/DD/YYYY" // Ensures MM/DD/YYYY format
              value={moment(searchFilters.startDate, "YYYY-MM-DD")}
              onChange={(e) => {
                setSearchFilters({
                  startDate: moment(e).format("YYYY-MM-DD"),
                });
              }}
              slotProps={{
                textField: {
                  readOnly: true,
                },
              }}
              minDate={getMinDateForLimited()}
            />
          </FormControl>
        </Grid>
        <Grid item md={4} xs={12}>
          <FormControl fullWidth>
            <Typography
              id="font-600"
              style={{
                marginBottom: "11px",
                color: "rgb(30, 30, 30)",
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: "500 !important",
              }}
            >
              {t("End Date")}
            </Typography>
            <DatePicker
              format="MM/DD/YYYY" // Ensures MM/DD/YYYY format
              minDate={moment(searchFilters.startDate, "YYYY-MM-DD")} // Correct way to set minDate
              value={moment(searchFilters.endDate, "YYYY-MM-DD")}
              onChange={(e) => {
                setSearchFilters({
                  endDate: moment(e).format("YYYY-MM-DD"),
                });
              }}
              slotProps={{
                textField: {
                  readOnly: true,
                },
              }}
            />
          </FormControl>
        </Grid>
        <Grid item md={4} xs={12}>
          <Button
            size="large"
            variant="contained"
            disableElevation
            color="primary"
            onClick={applyAction}
            className="ml-1 mb-1 comman-button"
          >
            {t("Apply")}{" "}
          </Button>
        </Grid>
      </Grid>
      <Divider />
      </>
      )}
      <div className="d-flex mb-2 mt-2 justify-content-between">
        <h1 className="pagename-heading">{t("Z - Out Report")}</h1>
        <div style={{ display: "flex", gap: "10px", marginRight: "20px" }}>
          <ReactToPrint
            trigger={() => {
              return (
                <Button
                  className="comman-button"
                  size="large"
                  variant="contained"
                  disableElevation
                  type="submit"
                  color="primary"
                >
                  {t("Print")}
                </Button>
              );
            }}
            content={() => componentRef}
            pageStyle={`
                @page {
                  size: A4;
                  margin: 11mm 8mm 17mm 8mm;
                }
  
                  * {
                -webkit-print-color-adjust: exact !important; /* Preserve colors for Webkit browsers */
                print-color-adjust: exact !important; /* Preserve colors for other browsers */
              }
               
              `}
            documentTitle={
              "Z-Out Report - " +
              moment(searchFilters?.startDate, "YYYY-MM-DD").format(
                "MM/DD/YYYY"
              ) +
              " to " +
              moment(searchFilters?.endDate, "YYYY-MM-DD").format("MM/DD/YYYY")
            }
          />
          <div style={{ display: "none" }}>
            <ZOutReportPrint
              ref={(el) => (componentRef = el)}
              reportData={reportData}
              date={
                moment(searchFilters?.startDate, "YYYY-MM-DD").format(
                  "MMM-DD-YYYY"
                ) +
                " to " +
                moment(searchFilters?.endDate, "YYYY-MM-DD").format(
                  "MMM-DD-YYYY"
                )
              }
              t={t}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          borderTop: "2px solid",
          marginTop: "10px",
        }}
      ></div>
      <Grid container spacing={0.5} className="pl-2 pr-2 mt-3">
        <Grid
          item
          xs={8}
        >
          <Typography variant="h4" sx={{ fontSize: "17px" }}>
            {t("Advance Deposits Previous Balance")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h4" sx={{ fontSize: "17px" }}>
            $ {(+reportData?.advance_deposit_pre_bal || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {" "}
        </Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 3 }}>
            {t("Net Advance Payments")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.net_adv_pay || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 3 }}>
            {t("Plus T/A Commissions")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.plus_ta_comm || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 3 }}>
            {t("Refund By Check")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.refund_by_check || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 3 }}>
            {t("Refund By Cash or Credit Card")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.refund_by_cash_or_card || 0).toFixed(2)}
          </Typography>
        </Grid>

        <Grid item xs={12}></Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 1 }}>
            {t("Total Advance Deposit Credit")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.total_adv_dep_credits || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid item xs={12}></Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 1 }}>
            {t("Applied Deposits")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.applied_deposit || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid item xs={12}></Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h4" sx={{ fontSize: "17px" }}>
            {t("Advance Deposits Ending Balance")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h4" sx={{ fontSize: "17px" }}>
            $ {(+reportData?.adv_dep_ending_bal || 0).toFixed(2)}
          </Typography>
        </Grid>
      </Grid>
      <div className="px-2 my-2">
        <Typography variant="h4" sx={{ fontSize: "22px!important" }}>
          {t("Bank Deposits")}
        </Typography>
      </div>
      <div className="px-2" style={{ overflow: "scroll" }}>
        <Table
          // className="mt-2"
          size="small"
          sx={{
            borderCollapse: "collapse",
            overflowX: "auto",
            "& .MuiTableCell-sizeSmall": {
              padding: "6px",
            },
            minWidth: "600px",
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Pay Type")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Guest Ledger")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("City Ledger")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Adv Dep Ledger")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Total")}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reportData?.bank_deposits?.map((item) => {
              return (
                <StyledTableRow>
                  <TableCell item xs={4}>
                    {item?.pay_type}
                  </TableCell>
                  <TableCell item xs={4}>
                    {(+item?.guest_ledger || 0).toFixed(2)}
                  </TableCell>
                  <TableCell item xs={4}>
                    {(+item?.city_ledger || 0).toFixed(2)}
                  </TableCell>
                  <TableCell item xs={4}>
                    {(+item?.adv_deposit_ledger || 0).toFixed(2)}
                  </TableCell>
                  <TableCell item xs={4}>
                    <b>{(+item?.total || 0).toFixed(2)}</b>
                  </TableCell>
                </StyledTableRow>
              );
            })}

            <TableRow sx={{ borderTop: "2px solid black" }}>
              <TableCell item xs={4}>
                <b>{t("Total")}</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>
                  {reportData?.bank_deposits
                    ?.reduce((sum, item) => {
                      return sum + (+item.guest_ledger || 0); // Convert to number and add to the sum
                    }, 0)
                    .toFixed(2)}
                </b>
              </TableCell>
              <TableCell item xs={4}>
                <b>
                  {reportData?.bank_deposits
                    ?.reduce((sum, item) => {
                      return sum + (+item.city_ledger || 0); // Convert to number and add to the sum
                    }, 0)
                    .toFixed(2)}
                </b>
              </TableCell>
              <TableCell item xs={4}>
                <b>
                  {reportData?.bank_deposits
                    ?.reduce((sum, item) => {
                      return sum + (+item.adv_deposit_ledger || 0); // Convert to number and add to the sum
                    }, 0)
                    .toFixed(2)}
                </b>
              </TableCell>
              <TableCell item xs={4}>
                <b>
                  {reportData?.bank_deposits
                    ?.reduce((sum, item) => {
                      return sum + (+item.total || 0); // Convert to number and add to the sum
                    }, 0)
                    .toFixed(2)}
                </b>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <div className="px-2 my-2">
        <Typography variant="h4" sx={{ fontSize: "22px!important" }}>
          {t("Deposits By Clerk")}
        </Typography>
      </div>
      <div className="px-2" style={{ overflow: "scroll" }}>
        <Table
          // className="mt-2"
          size="small"
          sx={{
            borderCollapse: "collapse",
            overflowX: "auto",
            "& .MuiTableCell-sizeSmall": {
              padding: "6px",
            },
            minWidth: "600px",
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Clerk")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("CASH")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("AMEX")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("VISA")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("DINERS")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("DISCOVER")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("CART BLA")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("MASTER C")}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <StyledTableRow>
              <TableCell item xs={4}>
                CO
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
            </StyledTableRow>

            <TableRow sx={{ borderTop: "2px solid black" }}>
              <TableCell item xs={4}>
                <b>Total</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <div className="px-2 my-2">
        <Typography variant="h4" sx={{ fontSize: "22px!important" }}>
          {t("Sales Batch")}
        </Typography>
      </div>
      <div className="px-2" style={{ overflow: "scroll" }}>
        <Table
          // className="mt-2"
          size="small"
          sx={{
            borderCollapse: "collapse",
            overflowX: "auto",
            "& .MuiTableCell-sizeSmall": {
              padding: "6px",
            },
            "& .MuiTableCell-root": {
              whiteSpace: "normal",
              wordWrap: "break-word",
            },
            minWidth: "600px",
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Shift /Staff /Clerk")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Booking Id")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Room")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Pay")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("How")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Pending Sale")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Auth")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Credit Card#")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Expr")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Card Holder")}
                </Typography>
              </TableCell>
              {/* <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Handle")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Trans ID")}
                </Typography> 
              </TableCell> */}
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Retrival Reference")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Invoice")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Date & Time")}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reportData?.sales_batch &&
              Object.entries(reportData?.sales_batch)?.map(([Key, items]) => (
                <>
                  <TableRow
                    sx={{
                      borderTop: "2px solid black",
                      borderBottom: "2px solid black",
                    }}
                  >
                    <TableCell colSpan={13}>
                      <Typography
                        variant="h4"
                        sx={{ fontSize: "16px!important" }}
                      >
                        {t("Sales For:")} {Key}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  {items?.map((item) => (
                    <StyledTableRow>
                      <TableCell item xs={4}>
                        {item?.shift}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.booking_id}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.room}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.pay}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.how}
                      </TableCell>
                      <TableCell item xs={4}>
                        {(+item?.pending_sale).toFixed(2)}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.auth}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.credit_card}
                      </TableCell>
                      <TableCell item xs={4}>
                        {splitNumber(item?.expr)}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.card_holder}
                      </TableCell>
                      {/* <TableCell item xs={4}>
                        [{+item?.handle === 0 ? " " : item?.handle}]
                      </TableCell>
                      <TableCell item xs={4}>
                        {+item?.trans_id === 0 ? " " : item?.trans_id}
                      </TableCell> */}
                      <TableCell item xs={4}>
                        {item?.retrieval_reference}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.invoice}
                      </TableCell>
                      <TableCell item xs={4}>
                      { moment.utc(item?.date_time).local().format("MM/DD/YYYY HH:mm A")}

                      </TableCell>
                    </StyledTableRow>
                  ))}

                  <TableRow sx={{ borderTop: "2px solid black" }}>
                    <TableCell colSpan={13}>
                      <div className="d-flex gap-2">
                        <span> {t("Sub Total")} :</span>{" "}
                        <span>
                          {" "}
                          {t("Count")} : {items?.length}
                        </span>{" "}
                        <span>
                          {" "}
                          {t("Total Sale")} : ${" "}
                          {items
                            ?.reduce((sum, item) => {
                              return sum + (+item.pending_sale || 0); // Convert to number and add to the sum
                            }, 0)
                            .toFixed(2)}
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>
                </>
              ))}
            <TableRow sx={{ borderTop: "2px solid black" }}>
              <TableCell colSpan={13}></TableCell>
            </TableRow>
            <TableRow sx={{ borderTop: "2px solid black" }}>
              <TableCell colSpan={13}>
                <div id="font-600" className="d-flex gap-2">
                  <span> {t("Total")} :</span>{" "}
                  <span>
                    {" "}
                    {t("Count")} :{" "}
                    {reportData?.sales_batch &&
                      Object.entries(reportData?.sales_batch)?.reduce(
                        (sum, [key, items]) => {
                          return sum + items?.length;
                        },
                        0
                      )}
                  </span>{" "}
                  <span>
                    {" "}
                    {t("Total Sale")} : $
                    {reportData?.sales_batch &&
                      Object.entries(reportData?.sales_batch)
                        ?.reduce((sum, [key, items]) => {
                          return (
                            sum +
                            +items?.reduce((sum, item) => {
                              return sum + (+item.pending_sale || 0); // Convert to number and add to the sum
                            }, 0)
                          );
                        }, 0)
                        .toFixed(2)}
                  </span>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      {/* <div className="px-2">
        <Typography sx={{ fontStyle: "italic" }} variant="h4">
          {t("Transmitted")}: {moment(searchFilters?.startDate, "YYYY-MM-DD").format("MM/DD/YYYY")}{" "}
          to {moment(searchFilters?.endDate, "YYYY-MM-DD").format("MM/DD/YYYY")} batch for - H
        </Typography>
        <Typography sx={{ fontStyle: "italic" }} variant="h4">
          {t("Sales transactions successfully transmitted")}
        </Typography>

        {reportData?.sales_batch &&
          Object.entries(reportData?.sales_batch)?.map(([Key, items]) => (
            <>
              {items?.map((item) => (
                <Grid container spacing={2}>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.shift}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.room}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.pay}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.how}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {(+item?.pending_sale).toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.auth}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.credit_card}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {splitNumber(item?.expr)}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.card_holder}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      [{+item?.handle === 0 ? " " : item?.handle}]
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {+item?.trans_id === 0 ? " " : item?.trans_id}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.retrieval_reference}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.invoice}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </>
          ))}
      </div> */}
      {/* <div
        className="mx-1 px-1 mt-2 py-2"
        style={{ borderTop: "1px solid black", width: "100%" }}
      >
        <Typography sx={{ fontStyle: "italic" }} variant="h4">
          <span> {t("Totals")} :</span>{" "}
          <span>
            {" "}
            {t("Count")} :{" "}
            {reportData?.sales_batch &&
              Object.entries(reportData?.sales_batch)?.reduce(
                (sum, [key, items]) => {
                  return sum + items?.length;
                },
                0
              )}
          </span>{" "}
          <span className="ml-2">
            {" "}
            {t("Total Sale")} : $
            {reportData?.sales_batch &&
              Object.entries(reportData?.sales_batch)
                ?.reduce((sum, [key, items]) => {
                  return (
                    sum +
                    +items?.reduce((sum, item) => {
                      return sum + (+item.pending_sale || 0); // Convert to number and add to the sum
                    }, 0)
                  );
                }, 0)
                .toFixed(2)}
          </span>
        </Typography>
      </div>
      <div className="px-2 mb-2">
        <Typography sx={{ fontStyle: "italic" }} variant="h4">
          {t("Sales Batch Transmission OK")} [/]
        </Typography>
      </div> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    reportData: state.report.zOutReportData,
    searchFilters: state.report?.zOutSearchFilters,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setReportData: (data) => dispatch(zOutReportDataSuccess(data)),
    searchFilterSuccess : (data) => dispatch(zOutSearchFiltersSuccess(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ZOutReport);

